import { LOC_CONFIRMATION_MESSAGE, LOC_MENU, LOC_MENU_TEXT } from "../../locKeys";
import { parseStringToBoolean } from "../../utils";
import { Trigger } from "./Trigger";

export class Menu extends Trigger {
    public identifier: string;
    public codename: string;
    public iconName: string;
    public participantsSelecting: boolean;
    public multiActionEnable: boolean;
    public validatePostReq: boolean;
    public validateRecommended: boolean;
    public chooseFromUsersDefault: boolean;
    public masterNode: string;
    public paramFormName: string;
    public linkAttrForSelObj: string;
    public setValues: string;
    public captions: Text[];
    public confirmMessages: Text[];

    constructor(identifier: string, codename: string, iconName: string, participantsSelecting: string, multiActionEnable: string, validatePostReq: string, validateRecommended: string, chooseFromUsersDefault: string, masterNode: string, paramFormName: string, linkAttrForSelObj: string, setValues: string, captions: Text[], confirmMessages: Text[]) {
        super();

        this.identifier = identifier;
        this.codename = codename;
        this.iconName = iconName;
        this.participantsSelecting = parseStringToBoolean(participantsSelecting, false);
        this.multiActionEnable = parseStringToBoolean(multiActionEnable, true);
        this.validatePostReq = parseStringToBoolean(validatePostReq, false);
        this.validateRecommended = parseStringToBoolean(validateRecommended, false);
        this.chooseFromUsersDefault = parseStringToBoolean(chooseFromUsersDefault, false);
        this.masterNode = masterNode;
        this.paramFormName = paramFormName;
        this.linkAttrForSelObj = linkAttrForSelObj;
        this.setValues = setValues;
        this.captions = captions;
        this.confirmMessages = confirmMessages;
    }

    public override async validate(): Promise<void> {
        if (!this.captions?.length || !this.captions[0].text)
            throw new Error(await this.getTriggerErrorMessage(LOC_MENU_TEXT, LOC_MENU));

        if (!this.confirmMessages?.length)
            throw new Error(await this.getTriggerErrorMessage(LOC_CONFIRMATION_MESSAGE, LOC_MENU));
    }
}

export class Text {
    public lang: string;
    public text: string;

    constructor(lang: string, text: string) {
        this.lang = lang;
        this.text = text;
    }
}
